exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#app .wrapper[data-v-663f1b0a] {\n  background: #fff;\n}\n.section-box[data-v-663f1b0a] {\n  padding-left: 1em;\n  text-indent: -1em;\n}\n", ""]);
